import type { WithCollapsedContact, Contact, CollapsedContact } from './contacts';
import { ref } from 'vue';
import { isSameContacts, toCollapsedContact } from './contacts';

const hiddenContacts = ref<CollapsedContact[]>([]);

export function useHiddenContactsCache() {
  const addHiddenContact = (contact: WithCollapsedContact) => {
    hiddenContacts.value.push(toCollapsedContact(contact));
  };

  const removeHiddenContact = (contact: WithCollapsedContact) => {
    hiddenContacts.value = hiddenContacts.value.filter(
      (cachedContact) => !isSameContacts(cachedContact, contact)
    );
  };

  const isContactHidden = (contact: Contact | WithCollapsedContact) => {
    return hiddenContacts.value.some((cachedContact) => isSameContacts(cachedContact, contact));
  };

  const clearHiddenContacts = () => {
    hiddenContacts.value = [];
  };

  return {
    addHiddenContact,
    removeHiddenContact,
    isContactHidden,
    clearHiddenContacts
  };
}
